import Vue from "vue";
import Vuex from "vuex";

import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const WPVUE = window.WPVUE;

Vue.config.devtools = process.env.NODE_ENV === 'development'
Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		onlineState: navigator.onLine,
		taxonomiesLoaded: false,
		options: WPVUE.options || {},
		postsData: {
			post: [],
			page: [],
			people: [],
        },
		menus: {},
		
		authors: [],
		searchModalOpen: false,
		searchValue: '',
		mainNaviIsOpen: false,
		taxonomies: {
			education_level : [],
			work_place : [],
			category : [],
			category_ambasador : [],
			interests : [],
		},
		isOpenNav: true,
		pageIsLoading: true,
		storeVersion: false,
		cacheKey: (WPVUE && WPVUE.persistor_key) ? WPVUE.persistor_key : new Date().getTime(),
		title: '',

	},
	getters,
	mutations,
	actions
});
